import type { Theme } from '@src/app/themes';
import { formatIsoDate, hoursBetweenTime } from '@src/shared/lib';
import { Stack } from '@src/shared/ui/layout';
import Typography from '@src/shared/ui/Typography';

type TotalDatesOrHoursProps = {
  dateFrom: Date | null;
  dateTo: Date | null | undefined;
  startTime: string | null | undefined;
  endTime: string | null | undefined;
  hours: boolean;
  holidayDatesSet: Set<string>;
};

function countWorkdays(
  dateFrom: Date,
  dateTo: Date,
  holidayDatesSet: Set<string>,
): number {
  let count = 0;
  const current = new Date(
    dateFrom.getFullYear(),
    dateFrom.getMonth(),
    dateFrom.getDate(),
  );
  const end = new Date(
    dateTo.getFullYear(),
    dateTo.getMonth(),
    dateTo.getDate(),
  );
  while (current <= end) {
    const day = current.getDay();
    const isWeekend = day === 0 || day === 6;
    const isHoliday = holidayDatesSet.has(formatIsoDate(current));
    if (!isWeekend && !isHoliday) {
      count++;
    }
    current.setDate(current.getDate() + 1);
  }
  return count;
}

const StyleSheet = {
  total: (theme: Theme) => ({
    color: theme.palette.grey[800],
    background: theme.palette.grey[100],
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 10px',
    marginBottom: '20px',
    lineHeight: 1,
    height: '35px',
  }),
};
export default function TotalDatesOrHours({
  dateFrom,
  dateTo,
  startTime,
  endTime,
  hours,
  holidayDatesSet,
}: TotalDatesOrHoursProps) {
  const total = () => {
    let total = 0;
    if (!hours && dateFrom && dateTo)
      total = countWorkdays(dateFrom, dateTo, holidayDatesSet);
    if (hours && startTime && endTime)
      total = hoursBetweenTime(startTime, endTime);
    return total;
  };
  return (
    <Stack direction="row" sx={StyleSheet.total}>
      <Typography variant="body1">Total {hours ? 'Hours' : 'Days'}</Typography>
      <Typography variant="body1">{total()}</Typography>
    </Stack>
  );
}
